import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useSettings } from "@/lib/SettingsContext";
import { isPromoActive } from "@/lib/promo";

export const PromoBanner = () => {
  const promo = useSettings().promo;
  if (!isPromoActive(promo)) return null;

  return (
    <motion.div
      initial={{ y: -40 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 w-full z-[60] h-10 bg-[#F5A200] text-[#0a1730] flex items-center justify-center px-4 shadow-md"
      data-testid="promo-banner"
    >
      <div className="flex items-center gap-3 text-xs sm:text-sm font-bold text-center">
        <span className="truncate">{promo.bannerText}</span>
        {promo.bannerCtaUrl && promo.bannerCtaLabel && (
          <a
            href={promo.bannerCtaUrl}
            className="hidden sm:inline-flex items-center gap-1 rounded-full bg-[#0a1730] text-white hover:bg-[#0a1730]/85 px-3 py-1 transition-colors whitespace-nowrap"
            data-testid="promo-banner-cta"
          >
            {promo.bannerCtaLabel} <ArrowRight size={13} />
          </a>
        )}
      </div>
    </motion.div>
  );
};
